import api from "@/application";

const DOWNLOAD_SOURCES = ["https://sapsrm.beloil.by"];

const NEW_TAB_SOURCES = [
  "https://zakupki.minsktrans.by",
  "https://naftan.by",
  "https://belaruskali.by",
  "https://belarus-tr.gazprom.ru",
  "https://goszakupki.by",
  "https://zakupki.butb.by",
  "http://zakupki.butb.by",
  "https://icetrade.by",
  "https://becloud.by",
  "https://a-100development.by",
  "https://www.belveb.by",
  "https://tws.butb.by",
  "https://zakupki.mts.by",
];

const getFileUrl = (file) => file?.url || file;

const openDocumentInNewTab = (file) => {
  const url = getFileUrl(file);

  if (!url) return;

  const link = document.createElement("a");

  link.href = url;
  link.target = "_blank";
  link.rel = "noopener noreferrer";

  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

const downloadDocument = async (file) => {
  const url = getFileUrl(file);

  if (!url) return;

  const params = {};

  new URL(url).searchParams.forEach((value, key) => {
    params[key] = value;
  });

  if ("d" in params) {
    params.d = encodeURIComponent(params.d);
  }

  const response = await api.documents.downloadFileForLot(params);
  const objectUrl = URL.createObjectURL(response.data);

  const link = document.createElement("a");

  link.href = objectUrl;
  link.download = file?.name || "document";

  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);

  URL.revokeObjectURL(objectUrl);
};

const openDocument = async (file, source) => {
  if (!file || !source) return;

  if (DOWNLOAD_SOURCES.includes(source)) {
    await downloadDocument(file);
    return;
  }

  if (NEW_TAB_SOURCES.includes(source)) {
    openDocumentInNewTab(file);
  }
};

const isSupportedSource = (source) =>
  DOWNLOAD_SOURCES.includes(source) || NEW_TAB_SOURCES.includes(source);

export { openDocument, isSupportedSource };
